module.exports = __webpack_public_path__ + "static/img/learn-blockchain.be0847f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-page/learn-blockchain.svg
// module id = d4pX
// module chunks = 1